module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/beauty-mobile@3x-e8b0c29c71496575a89184688ecad9ee.jpg";